module.exports = __webpack_public_path__ + "img/app3.c5379527.jpg";